import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import { IUseDeleteMutation, IDeleteFn, IGetDeleteRequest, ISafetyCaseHazard } from '../../interfaces'

const getDeleteSafetyCaseHazardMutationRequest: IGetDeleteRequest = () => ({
  method: 'delete',
  url: `${config.baseUrl}/sms/Hazards/`,
})

const useDeleteSafetyCaseHazardMutation: IUseDeleteMutation<ISafetyCaseHazard, number> = (
  params,
  options = {},
) => {
  const request = useMemo(() => getDeleteSafetyCaseHazardMutationRequest(params), [params])

  const deleteSafetyCaseHazard: IDeleteFn<ISafetyCaseHazard> = useCallback(
    async id => axios({ ...request, url: request.url + id }).then(res => res.data),
    [request],
  )

  const response = useMutation<ISafetyCaseHazard, Error, any>({ mutationFn: deleteSafetyCaseHazard, ...options })

  return response
}

export default useDeleteSafetyCaseHazardMutation
